import { ViteReactSSG } from 'vite-react-ssg/single-page'
import App from './pages/Home.jsx'
import './styles/main.css';
import 'aos/dist/aos.css';

export const createRoot = ViteReactSSG(<App />)